export function isDemoQuotaError(error: unknown): boolean {
    const data = (error as { response?: { status?: number; data?: { code?: string } } })?.response
    return data?.status === 429 && data?.data?.code === "demo_quota_exceeded"
}

export function demoQuotaMessage(scope: string | undefined): string {
    if (scope === "total") return "Дневной лимит демо для всего стенда исчерпан."
    return "Дневной лимит демо для вас исчерпан."
}

export const DEMO_QUOTA_EVENT = "recsys:demo-quota"
